var _excluded = ["children", "id", "selected", "unmountContent"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled, { css } from 'styled-components';
var StyledPanelContainer = styled.div.withConfig({
  componentId: "CL__sc-1v2crw7-0"
})(["&:focus{outline:none;}", ";"], _ref => {
  var {
    $selected,
    $unmountContent
  } = _ref;
  return !$unmountContent && css(["display:", ";"], $selected ? 'block' : 'none');
});
var TabPanel = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  var {
      children,
      id,
      selected = false,
      unmountContent = false
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledPanelContainer, _extends({
    $selected: selected,
    $unmountContent: unmountContent,
    "aria-labelledby": "".concat(id, "-tab"),
    "aria-hidden": selected ? 'false' : 'true',
    id: id,
    ref: ref,
    role: "tabpanel",
    tabIndex: 0
  }, props), unmountContent ? selected ? children : null : children);
});
export default TabPanel;